<template>
    <div class="protocol-select" :class="!showComponents ? 'protocol-select-opacity' : ''" v-if="currentComponent">
        <h3 class="font-weight-bold">
            {{ $t('contrato_rastreabilidade.messages.protocol.title') }}
        </h3>
        <el-card>
            <component
                v-model="form.protocol_id"
                :is="currentComponent"
                ref="protocolSelectComponent"
            />
        </el-card>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'ProtocolSelect',
    data() {
        return {
            components: {
                'PY': () => import('@/modules/traceability-contract/views/components/protocol-select/py.vue')
            }
        };
    },
    computed: {
        ...mapState('traceabilityContractModule', ['form']),
        currentComponent() {
            this.$emit('input', {});
            const user = this.$store.state.usuarioLogado;
            return this.components[user.paisGrupo];
        },
        showComponents() {
            return !!this.form.id;
        }
    }
};
</script>

<style scoped lang="scss">
h3 {
    margin: 16px 0;
    color: #3B3B3B;
    font-weight: 500;
    font-size: 16px;
}
.protocol-select-opacity {
    opacity: 0.5;
}
</style>
